export const environment = {
   
    production: false,
    apiUrl:location.origin + '/'
  };